var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"d9078b83eb8df17b0fe75bf093998018e4f24a84"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: process.env.NODE_ENV === 'production' ? true : false,

  // Performance tracing adds load to the system
  tracesSampleRate: 0.0075,

  // Half sample rate until we get on top of our exceptions
  sampleRate: 0.05,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Copied from: https://gist.github.com/Chocksy/e9b2cdd4afc2aadc7989762c4b8b495a
  ignoreErrors: [
    // 3rd PARTY WALLETS
    // Ignore MM tx signature
    'MetaMask Tx Signature: User denied transaction signature.',
    'User rejected request',
    'Error: call revert exception',
    // END 3rd PARTY WALLETS

    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // Generic error code from errors outside the security sandbox
    // You can delete this if using raven.js > 1.0, which ignores these automatically.
    'Script error.',
    // Avast extension error
    '_avast_submit',

    // WALLETCONNECT
    'WebSocket connection failed for host: wss://relay.walletconnect.org',
    'Socket stalled when trying to connect to wss://relay.walletconnect.org',
    'No internet connection detected. Please restart your network and try again.',
    // END WALLETCONNECT

    // Error seen on 3rd party pages using zora iframe embeds
    `Failed to read a named property 'ethereum' from 'Window': Blocked a frame with origin "https://zora.co" from accessing a cross-origin frame.`,
  ],
  denyUrls: [
    // block this particular extension which errors on every page load
    /chrome-extension:\/\/ebfidpplhabeedpnhjnobghokpiioolj/i,
    // Google Adsense
    /pagead\/js/i,
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^@webkit-masked-url/i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  ],
})
